interface IQueries {
  getSingleApplication: string
  overrideIncome: string
  addIncome: string
  getInternalTouchpoints: string
  getSubjectTouchpoints: string
  addTouchpoint: string
  cancelDocumentRequest: string
  addOpenBankingRequest: string
  updatePriceShare: string
  switchCustomer: string
  submitLandlordReference: string
  deleteTouchpoint: string
}

const QUERIES: IQueries = {
  switchCustomer: `mutation($personId: String!, $customerId: String!){
    switchCustomer(personId: $personId, customerId: $customerId) {
      message
      status
      body {
        workspaceSettings {
          lastAccessedCustomer {
            id
            name
          }
        }
      }
    }
  }`,
  getSingleApplication: `query(
    $customerId: String!
    $applicationId: String!
    $subjectId: String!
    $logicAppRun: String
    $personId: String
  ) {
    getDashboardApplication(
      customerId: $customerId
      applicationId: $applicationId
      subjectId: $subjectId
      logicAppRunId: $logicAppRun
      personId: $personId
    ) {
      customerClientName
      type
      avatar
      applicationId
      subjectId
      customerId
      name
      firstName
      studentIDContext
      IDVTIDCheckStatus
      IDVTR2RStatus
      hasPendingIDVTChecks
      outcome {
        status
        comments
        sections {
          name
          status
          properties {
            name
            status
          }
        }
      }
      reference {
        ... on LandlordReference {
          properties {
            rentDeductions
            rentWasPaidLate
            numberOfTimesRentWasLate
            validPersonForReference
            monthlyRent
            propertyLeftInGoodCondition
            propertyConditionDetails
            wouldRentToTenantAgain
            wouldRentToTenantAgainDetails
            term {
              startDate
              endDate
              knownEndDate
              numberOfWeeksNotice
              endOfTenancyConfirmation {
                noticeGiven
                canBeLeftEarly
              }
            }
            tenants {
              id
              outcome {
                status
                comments
              }
            }
            address {
              name
              line1
              line2
              city
              country
              postcode
            }
          }
        }
        ... on EmployerReference {
          referenceEmploymentId
          refereeRelationship
          contractExtension
          referenceMethod
          jobTitle
          contractType
          contractFrequency
          startDate
          endDate
          additionalContext
          supportingDocuments {
            documentReference
            thumbnail
            type
            isValid
          }
          outcome {
            status
            comments
          }
          income {
            value
            currency {
              code
              name
              symbol
            }
            frequency
            averageHoursAWeek
          }
          guaranteedBonus{
            value
            currency {
              code
              name
              symbol
            }
            frequency
          }
        }
        ... on AccountantReference {
          incomeSource
          startDate
          additionalContext
          outcome {
            status
            comments
          }
          taxReturnYearPeriod
          incomeConfirmationType
          income {
            value
            currency {
              code
              name
              symbol
            }
            frequency
            averageHoursAWeek
          }
          supportingDocuments {
            documentReference
            thumbnail
            type
            isValid
          }
        }
      }
      advisories {
        name
        description
        category
        isActive
      }
      journeyConfig {
        buildReportFromOutcome
        referenceGroup
        openBankingProvider
        identityProvider
        idvt
        chaseType
        swimLaneGroup
        mandatedTrustedSourcesEnabled
      }
      context {
        firstName
        lastName
        middleName
        email
        mobile
        jobRole
        dob
        nationality
        name
        journeyType
        company {
          name
          companyNumber
          incorporationDate
          address{
            name
            line1
            line2
            city
            country
            postcode
          }
          credit {
            creditScore
            creditLimit
            ccJs {
              state
              amount
              courtDate
            }
            verifiedBy {
              name
              email
            }
          }
          finance {
            assets
            liabilities
            unrestrictedFunds
            cashAndEquivalent
            netAssets
            currentRatio
            verifiedBy {
              name
              email
            }
          }
          verification {
            companyHouseCheck
            companyType
            incorporationDate
            organisationStatus
            filedAccount
            companyNumber
            verifiedBy {
              name
              email
            }
          }
        }
        credit {
          provider
          identityConfirmed
          residencyConfirmed
          declaredCredit {
            type
            amount
            address
          }
          adverseCredit {
            type
            amount
            address
            status
            caseNumber
            courtDate
          }
        }
        fraud {
          status
          reason
          decision
        }
        incomes {
          id
          type
          status
          company
          position
          contractType
          contractSchedule
          startDate
          endDate
          provider
          institution
          idNumber
          hasAddedAccountantDetails
          directorPayType
          validation {
            validatorId
            state
            validationSources
            validatorPerson {
              name
              email
            }
            unableToVerifyReason
            confirmed{
              income{
                value
                currency {
                  code
                  name
                  symbol
                }
                frequency
                averageHoursAWeek
              }
              guaranteedBonus{
                value
                currency {
                  code
                  name
                  symbol
                }
                frequency
                averageHoursAWeek
              }
            }
          }
          employerReference {
            subjectId
            name
            firstName
            lastName
            phone
            email
            jobRole
            referenceEmploymentId
            referenceMethod
            jobTitle
            contractType
            contractFrequency
            startDate
            endDate
            additionalContext
            refereeRelationship
            contractExtension
            supportingDocuments {
              documentReference
              thumbnail
              type
              isValid
            }
            outcome {
              status
              comments
            }
            income {
              value
              currency {
                code
                name
                symbol
              }
              frequency
              averageHoursAWeek
            }
            guaranteedBonus {
              value
              currency {
                code
                name
                symbol
              }
              frequency
              averageHoursAWeek
            }
          }
          accountantReference {
            subjectId
            mobile
            name
            email
            jobRole
            startDate
            incomeSource
            taxReturnYearPeriod
            incomeConfirmationType
            income {
              value
              currency {
                code
                name
                symbol
              }
              frequency
              averageHoursAWeek
            }
            outcome {
              status
              comments
            }
          }
          address {
            id
            nameOrNumber
            normalizedLine1
            name
            line1
            line2
            city
            country
            postcode
          }
          evidenceType
          taxReturnYearPeriod
          supportingDocuments {
            documentReference
            thumbnail
            type
            isValid
          }
          guaranteedBonus {
            value
            currency {
              code
              name
              symbol
            }
            frequency
            averageHoursAWeek
          }
          incomeProperties {
            value
            currency {
              code
              symbol
              name
            }
            frequency
            averageHoursAWeek
          }
          konfirIntegration {
            status
            outcome {
              status
              reasons
            }
            optOutReason {
              category
              additionalInformation
            }
          }
          openBankingConnections {
            source
            status
            completedAt
            optOutReason {
              category
              additionalInformation
            }
            outcome {
              estimatedNetIncome
              estimatedGrossIncome
              balance
              comments
              incomeId
            }
            connectionFailures {
              timestamp
              reason
            }
            reportUrl
          }
          documentBypassReason {
            category
            additionalInformation
          }
          trustedSourcesRequired
        }
        documents {
          fileName
          thumbnail
          watermarkedFileName
          watermarkedThumbnail
          specifiedType
          id
          createdAt
          updatedAt
          uploadedBy{
            id
            type
            authorName
            authorEmail
          }
          properties{
            authorName
            createdDate
            modifiedDate
            documentTitle
            softwareUsedToCreate
          }
          requestDetails {
            additionalContext
            documentSection
          }
        }
        employment {
          status
          company
          position
          referee
        }
        financial {
          maximumAffordabiity
          affordabilityThreshold
          totalIncome
          totalOutgoing
          openBanking {
            status
            integrationId
            incomeId
            optOutReason {
              category
              additionalInformation
            }
            outcome {
              estimatedNetIncome
              estimatedGrossIncome
              balance
              comments
              incomeId
            }
            connectionFailures {
              timestamp
              reason
            }
          }
        }
        addresses {
          isRegisteredOwner
          electoralRollConfirmation {
            status
            yearsConfirmed
          }
          bedroomIdentifier
          normalizedLine1
          id
          name
          line1
          status
          line2
          evidence
          startDate
          addressType
          durationAtAddress
          city
          postcode
          county
          country
          verification {
            state
          }
          paymentDetails {
            isFromBankAccount
            recipient
            amount
          }
          reference {
            rentDeductions
            rentWasPaidLate
            numberOfTimesRentWasLate
            validPersonForReference
            monthlyRent
            propertyLeftInGoodCondition
            propertyConditionDetails
            wouldRentToTenantAgain
            wouldRentToTenantAgainDetails
            term {
              startDate
              endDate
              knownEndDate
              numberOfWeeksNotice
            }
            tenants {
              id
              outcome {
                status
                comments
              }
            }
            address {
              id
              name
              line1
              line2
              city
              country
              postcode
            }
            submittedBy{
              id
              type
              authorName
              authorEmail
            }
            mobile
            name
            subjectId
            outcome {
              status
              comments
            }
          }
        }
        identity {
          idNumber
          idFirstName
          idLastName
          idDob
          nationality
          idType
          selfieEvidence
          facialMatch
          facialMatchConfidence
          idEvidence
          r2RShareCode
          applicantProvidedRightToRentCode
          rightToRentAdditionalContext
          expiryDate
          issueDate
          nationalInsuranceNumber
          verification {
            idCheckStatus
            r2RStatus
          }
        }
        country {
          name
          nationality
        }
        emergencyContactDetails {
          name
          relationship
          email
          phone
        }
      }
      identityData {
        items {
          key
          value
          status
          location
          details
        }
        documentProof
      }
      employmentData {
        items {
          key
          value
          status
          location
          details
        }
      }
      additionalQuestions {
        items {
          answer
          promptId
          key
          value
        }
      }
      subjectAssets {
        attributes {
          priceShare
          affordabilityRatio
        }
        type
      }
      results {
        name
        outcome
        documentProof
        properties {
          name
          supportingData
          dataMatches
          decisionInfo
          result
        }
      }
      assets {
        price
        attributes {
          address {
            nameOrNumber
            line1
            line2
            city
            country
            postcode
          }
          term
          price
          startDate
        }
      }
      additionalTenants {
        name
        avatar
        customerId
        applicationId
        subjectId
        type
        email
        outcome {
          status
        }
      }
      attachedSubjects {
        name
        type
        avatar
        customerId
        applicationId
        subjectId
        email
        outcome {
          status
        }
      }
      milestones {
        event
        createdAt
      }
      agent {
        name
        phone
      }
    }
  }
  `,
  overrideIncome: `mutation($overrideIncomeRequest: OverrideIncomeRequest!){
  overrideIncome(overrideIncomeRequest: $overrideIncomeRequest) { status, message }
}`,
  addIncome: `mutation($addIncomeRequest: AddIncomeRequest!){
  addIncome(addIncomeRequest: $addIncomeRequest)
}`,
  addOpenBankingRequest: `mutation($customerId: String!, $applicationId: String!, $subjectId: String!, $personId: String!, $requestMessage: String!, $incomeId: String!){
  addOpenBankingRequest(customerId: $customerId, applicationId: $applicationId, subjectId: $subjectId, personId: $personId, requestMessage: $requestMessage, incomeId: $incomeId)
}`,
  updatePriceShare: `mutation($customerId: String!, $applicationId: String!, $subjectId: String!, $priceShare: Float!){
  updatePriceShare(customerId: $customerId, applicationId: $applicationId, subjectId: $subjectId, priceShare: $priceShare)
}`,
  getSubjectTouchpoints: `query($customerId: String!, $applicationId: String!, $subjectId: String!){
  getSubjectTouchpoints(customerId: $customerId, applicationId: $applicationId, subjectId: $subjectId){
    id
    customerId
    applicationId
    subjectId
    type
    category
    softDeleted
    author{
      id
      type
      details{
        name
        email
      }
    }
    resourceIdentifier
    createdAt
    updatedAt
    message
  }

}`,

  getInternalTouchpoints: `query($customerId: String!, $applicationId: String!, $subjectId: String!){
  getInternalTouchpoints(customerId: $customerId, applicationId: $applicationId, subjectId: $subjectId){
    id
    customerId
    applicationId
    subjectId
    type
    category
    author{
      id
      type
      details{
        name
        email
      }
    }
    resourceIdentifier
    createdAt
    updatedAt
    message
  }
}`,

  addTouchpoint: `mutation($touchpoint: TouchpointInput!){
  addTouchpoint(touchpoint: $touchpoint){
    id
    customerId
    applicationId
    subjectId
    type
    category
    author{
      id
      type
    }
    resourceIdentifier
    createdAt
    updatedAt
    message
  }
}`,
  cancelDocumentRequest: `mutation(
  $customerId: String!
  $applicationId: String!
  $subjectId: String!
  $recommendationId: String!
  $notifyApplicant: Boolean!
) {
  cancelDocumentRequest(
    customerId: $customerId
    applicationId: $applicationId
    subjectId: $subjectId
    recommendationId: $recommendationId
    notifyApplicant: $notifyApplicant
  )
}`,
  submitLandlordReference: `mutation($request: SubmitLandlordRequest!) {
  submitLandlordReference(request: $request) {
    message
    status
  }
}`,
  deleteTouchpoint: `mutation($id: String!){
  deleteTouchpoint(id: $id){
    id
  }
}`,
}

export default QUERIES
